import { VENUE_LABELS } from './FilterTypes';

export const CURATED_PICKS_TYPE = Object.freeze({
  SIGNATURE_COLLECTION: 'signature_collection',
  EVENTS: 'event',
  DATE_NIGHT: VENUE_LABELS.DATE_NIGHT,
  BRUNCH: VENUE_LABELS.BRUNCH,
  OUTDOOR: VENUE_LABELS.OUTDOOR,
  SPECIAL_EVENTS: VENUE_LABELS.SPECIAL_EVENTS,
  BIG_GROUPS: VENUE_LABELS.BIG_GROUPS,
});
